import Vue from "vue";
import Buefy from "buefy";
import numberFormat from "underscore.string/numberFormat";
import moment from "moment";
import config from './config';
import axios from 'axios';

window._ = require("lodash").default;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie..
 */

axios.defaults.baseURL = config.apiBaseUrl;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.interceptors.request.use(
  function (c) {
    c.baseURL = config.apiBaseUrl
    c.headers['Authorization'] = `Bearer ${Vue.prototype.$auth.token}`
    return c;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// if (process.env.NODE_ENV == "development") {
//   let token = window.localStorage.getItem("access_token");
//   axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
// }

// Creates a new promise that automatically resolves after some timeout:
Promise.delay = function (time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
};

// Throttle this promise to resolve no faster than the specified time:
Promise.prototype.takeAtLeast = function (time) {
  return new Promise((resolve, reject) => {
    Promise.all([this, Promise.delay(time)]).then(([result]) => {
      resolve(result);
    }, reject);
  });
};

// User Buefy
Vue.use(Buefy, {
  defaultDateFormatter: (date) => moment(date).format("YYYY-MM-DD"),
  defaultFirstDayOfWeek: 1,
});

import Form from "./core/Form";
import RemoteData from "./core/RemoteData";
import RemoteCollection from "./core/RemoteCollection";
import PaginatedRemoteCollection from "./core/PaginatedRemoteCollection";
import LazyLoadingRemoteCollection from "./core/LazyLoadingRemoteCollection";
import FailedResponseHandler from "./core/FailedResponseHandler";
import Uploader from "./core/Uploader";

window.Form = Form;
window.RemoteData = RemoteData;
window.RemoteCollection = RemoteCollection;
window.PaginatedRemoteCollection = PaginatedRemoteCollection;
window.LazyLoadingRemoteCollection = LazyLoadingRemoteCollection;
window.FailedResponseHandler = FailedResponseHandler;
window.Uploader = Uploader;

Vue.prototype.$http = axios;

Vue.component("page", require("./components/Page").default);
Vue.component("datepicker", require("./components/Datepicker").default);
Vue.component("datetimepicker", require("./components/DateTimePicker").default);
Vue.component("user-tile", require("./components/UserTile").default);
Vue.component("loading-box", require("./components/LoadingBox").default);
Vue.component(
  "modal-opener",
  require("./components/global/ModalOpener").default
);
Vue.component(
  "modal-opener-full",
  require("./components/global/ModalOpenerFull").default
);
Vue.component("data-loader", require("./components/global/DataLoader").default);
Vue.component("modal-card", require("./components/global/ModalCard").default);
Vue.component("empty-message", require("./components/EmptyMessage").default);

Vue.component("confirm-dialog", require("./components/ConfirmDialog").default);

Vue.component(
  "country-code-select",
  require("./components/select/CountryCodeSelect").default
);

Vue.component(
  "country-select",
  require("./components/select/CountrySelect").default
);

Vue.component(
  "language-select",
  require("./components/select/LanguageSelect").default
);

Vue.component(
  "magazine-select",
  require("./modules/admin/components/selectors/MagazineSelector").default
);

Vue.component(
  "magazine-category-select",
  require("./components/select/MagazineCategorySelect").default
);

Vue.component(
  "publisher-select",
  require("./modules/admin/components/selectors/PublisherSelect").default
);

Vue.component(
  "subscription-plan-select",
  require("./components/select/SubscriptionPlanSelect").default
);

Vue.component(
  "subscription-plan-type-select",
  require("./components/select/SubscriptionPlanTypeSelect").default
);

Vue.component(
  "magazine-issue-select",
  require("./components/select/MagazineIssueSelect").default
);

Vue.component(
  "clipboard-input",
  require("./components/ClipboardInput").default
);

Vue.component("links-dropdown", require("./components/LinksDropdown").default);

Vue.component("publish-button", require("./components/Publish").default);
Vue.component("flag-img", require("./components/FlagImg").default);

Vue.directive("sortable", require("./directives/Sortable").default);
Vue.directive("bg-image", require("./directives/BackgroundImageStyle").default);

Vue.filter("money", (number) => {
  return numberFormat(number, 2, ",", ".");
});

Vue.filter("date", (dateString) => {
  return moment(dateString).format("YYYY-MM-DD");
});

Vue.filter("dateTime", (dateString) => {
  return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
});

Vue.filter("fromNow", (dateString) => {
  return moment(dateString).fromNow();
});

Vue.filter("time", (seconds) => {
  let date = new Date(null);
  date.setSeconds(seconds);
  return date.toISOString().substr(11, 8);
});

Vue.filter("duration", seconds => {
  let h = parseInt(seconds / (60 * 60));
  let m = parseInt((seconds - h * 60 * 60) / 60);
  let s = seconds - h * 60 * 60 - m * 60;
  return (h > 0 ? h + "h " : "") + (m > 0 ? m + "m " : "") + (s + "s");
});
